import { Injectable } from '@angular/core';
import { environment } from  './../../environments/environment';
export const API_BASE_URL =    environment.API_BASE_URL;

export const API_ENDPOINT_CREATE = API_BASE_URL + 'shortener';
export const API_ENDPOINT_GET = '..... ';
export const API_ENDPOINT_DELETE = '..... ';
export const API_ENDPOINT_UPDATE = '..... ';
export const API_DOMAIN_URL = environment.API_DOMAIN_URL; // 'https://short.bosch.com/';
export class Constants {
  public readonly API_ENDPOINT_CREATE: string = '';
  public readonly API_MOCK_ENDPOINT: string = '';
  public static TitleOfSite: string = '';
}

export class SocialMedia {
  public readonly BC_API_ENDPOINT: string = '';
  public readonly BT_API_MOCK_ENDPOINT: string = '';
  public readonly NLI_API_MOCK_ENDPOINT: string = '';
}



export class authConfig {
  public static IS_SSO_Integrated: boolean = true;
  public static IS_Security_Headers: boolean = true;
}

export class uxControls {
  public static maximumCharacterShortName: number = 35;
  public static recycleBinDays: number = 7; // Days before permanent deletion
  
  // UI timeout values (in milliseconds)
  public static uiRefreshDelay: number = 1000; // Delay before refreshing UI after operations
  public static errorClearDelay: number = 1000; // Delay before clearing error flags
  public static notificationDuration: number = 3000; // Duration for all notifications
  
  // API pagination settings
  public static maxLinksToFetch: number = 100000; // Maximum number of links to fetch from API
}
